var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAnalysis105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.5 16a.5.5 0 0 0 0 1h60a.5.5 0 0 0 0-1h-60Zm0 24a.5.5 0 0 0 0 1h28a.5.5 0 0 0 0-1h-28Zm0 24a.5.5 0 0 0 0 1h28a.5.5 0 0 0 0-1h-28ZM9 88.5a.5.5 0 0 1 .5-.5h60a.5.5 0 0 1 0 1h-60a.5.5 0 0 1-.5-.5Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M54 52.5C54 43.94 60.94 37 69.5 37 78.06 37 85 43.94 85 52.5a15.451 15.451 0 0 1-4.574 10.994A15.451 15.451 0 0 1 69.5 68C60.94 68 54 61.06 54 52.5Zm26.809 12.015A16.443 16.443 0 0 1 69.5 69C60.387 69 53 61.613 53 52.5S60.387 36 69.5 36 86 43.387 86 52.5c0 4.376-1.704 8.355-4.484 11.308l14.338 14.338a.5.5 0 0 1-.707.707L80.809 64.515Z",
  clipRule: "evenodd"
})));
export { SvgAnalysis105 as ReactComponent };
export default __webpack_public_path__ + "6b153e45cc84a1ba56c0a74ff50e6d69.svg";